import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useTriage from "../../data/useTriage";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import openInNewTab from "../../utils/openInNewTab";

type TriageButtonProps = {
  vehicleId: string;
  triageId?: string | null;
  openInNewTab?: boolean;
  navigateOnCreate?: boolean;
  classes?: string;
};

export default function TriageButton({
  vehicleId,
  triageId,
  openInNewTab: shouldOpenInNewTab = true,
  navigateOnCreate = true,
  classes = "",
}: TriageButtonProps) {
  const navigate = useNavigate();
  const { saveHandlers } = useDefaultCRUDHandlers("Triage");
  const [activeTriageId, setActiveTriageId] = useState<string | undefined>(triageId ?? undefined);
  const { triage, createTriage } = useTriage(activeTriageId, vehicleId);

  useEffect(() => {
    setActiveTriageId(triageId ?? undefined);
  }, [triageId]);

  const hasTriage = !!activeTriageId;
  const isTriageComplete = !!triage.data?.data?.completed;

  const openTriage = (id: string) => {
    const path = `/triage/${id}`;
    if (shouldOpenInNewTab) {
      openInNewTab(path);
      return;
    }

    navigate(path);
  };

  const handleTriage = () => {
    createTriage.mutate(
      { vehicleId },
      {
        onSuccess: (res) => {
          setActiveTriageId(res.data.id);
          saveHandlers.onSuccess();
          if (navigateOnCreate) {
            openTriage(res.data.id);
          }
        },
        onError: saveHandlers.onError,
      }
    );
  };

  if (hasTriage) {
    return (
      <ButtonInput
        label={isTriageComplete ? "Triage Complete" : "View Triage"}
        onClick={() => openTriage(activeTriageId!)}
        classes={classes}
      />
    );
  }

  return (
    <ButtonInput
      label="Start Triage"
      onClick={handleTriage}
      isLoading={createTriage.isLoading}
      classes={classes}
    />
  );
}
